import { useParams } from 'react-router-dom';
import useSWR from 'swr';

import { generateApiPath, getCollection } from '#app/Handler/api';
import OrderClientLitigeEntryPoints from '#app/entrypoints/orderClientLitige';
import { DisputeListByClient } from '#app/typings/orderClientLitige';

type HookReturn = {
  disputes: DisputeListByClient[];
  loading: boolean;
};

const useDisputes = (): HookReturn => {
  const { uuid } = useParams<{ uuid: string }>();
  const { data: disputes, isLoading } = useSWR<DisputeListByClient[]>(
    generateApiPath(OrderClientLitigeEntryPoints.getCollectionByClient, { uuid: uuid as string }),
    getCollection,
  );

  return {
    disputes: disputes ?? [],
    loading: isLoading,
  };
};

export default useDisputes;
